// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9cb09417","239":"b8eb2d3c","453":"0422ae75","732":"7d68c9e1"}[chunkId] + ".chunk.js";
};